<template>
  <div class="personal-panel">
    <div class="personal-desc" :style="{'background':this.$store.state.app.themeColor}">
        <div class="avatar-container">
          <img class="avatar" :src="require('@/assets/logo.png')" />
        </div>  
        <div class="name-role">
          <span class="sender">{{ user.name }} - {{ user.role }}</span>  
        </div>  
        <!-- <div class="registe-info">
          <span class="registe-info">
            <li class="fa fa-clock-o"></li>
            {{ user.registeInfo }}
          </span>
        </div>   -->
    </div>
    <!-- <div class="personal-relation">
        <span class="relation-item">followers</span>  
        <span class="relation-item">watches</span>  
        <span class="relation-item">friends</span>
    </div> -->
    <!-- <div class="main-operation">
        <span class="main-operation-item">
          <el-button size="small" icon="fa fa-male"> 个人中心</el-button>
        </span>    
        <span class="main-operation-item">
          <el-button size="small" icon="fa fa-key"> 修改密码</el-button>
        </span>    
    </div> -->
    <div class="other-operation">
        <div class="other-operation-item" @click='retrieve'>
          <li class="fa fa-key"></li>
          修改密码
        </div>
        <div class="other-operation-item">
          <li class="fa fa-cog"></li>
          <theme-picker class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
        </div>
        <!-- <div class="other-operation-item">
          <li class="fa fa-eraser"></li>
          清除缓存
        </div>    
        <div class="other-operation-item">
          <li class="fa fa-user"></li>
          在线人数
        </div>    
        <div class="other-operation-item">
          <li class="fa fa-bell"></li>
          访问次数
        </div>    
        <div class="other-operation-item" @click="showBackupDialog">
          <li class="fa fa-undo"></li>
          {{$t("common.backupRestore")}}
        </div>     -->
    </div>
    <div class="personal-footer" @click="logout">
      <li class="fa fa-sign-out"></li>
      {{$t("common.logout")}}
    </div>
    <!--备份还原界面-->
    <!-- <backup ref="backupDialog" @afterRestore="afterRestore"></backup> -->

    <!-- 修改密码弹框 -->
    <div class="retrieve">
      <el-dialog title="修改密码" class="update" :visible.sync="visible" width="450px" append-to-body>
        <el-form :model="passform" ref="passform" :rules="passformRules" label-width="80px">
            <el-form-item label="新密码" prop="newPass">
              <el-input type="password" v-model="passform.newPass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPass">
              <el-input type="password" v-model="passform.confirmPass" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="visible = false">取 消</el-button>
            <el-button class="btnColor" @click="submitNewPass">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from "js-cookie"
// import Backup from "@/views/Backup/Backup"
import ThemePicker from "@/components/ThemePicker"
import axios from 'axios';
export default {
  name: 'PersonalPanel',
  components:{
    // Backup,
    ThemePicker,
  },
  props: {
    user: {
      type: Object,
      default: {
        name: "admin",
        avatar: "@/assets/user.png",
        role: "超级管理员",
        registeInfo: "注册时间：2018-12-25 "
      }
    }
  },
  data() {
    return {
      userInfo: '',
      visible: false,
      passform: {
        newPass: '',
        confirmPass: ''
      },
      passformRules: {
        newPass:[{required:true, message:'请输入新密码', trigger:'blur'}],
        confirmPass:[{required:true, message:'请确认新密码', trigger:'blur'}]
      }
    }
  },
  computed:{
    ...mapState({
      themeColor: state=>state.app.themeColor,
      headImg: state=>state.app.headImg,
      timeOut: state=>state.app.timeOut,
    }),
  },
  methods: {
    //修改密码
    retrieve() {
      this.visible = true
    },
    //确认新密码
    submitNewPass(){
      this.$refs.passform.validate(valid => {
        if(valid){
          if(this.passform.newPass===this.passform.confirmPass){
            let para = {
              "name": sessionStorage.getItem("user"),
              "password": this.passform.newPass
            }
            this.$api.user.updateUserPass(para).then(res => {
              if(res.code==200){
                this.$message({message: '重置密码成功', type: 'success'})
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('user')
                sessionStorage.removeItem('userInfo')
                // this.$store.commit('openTimeOut', false)
                let that = this
                setTimeout(function(){
                  that.$router.push("/login")
                },2000)
                
              }
            })
          }else{
            this.$message({message:'两次密码输入不一致', type: 'error'})
            this.visible = false
          }
        }
      })
    },
    // 退出登录
    logout: function() {
      this.$confirm("确认退出吗?", "提示", {
        type: "warning"
      })
      .then(() => {
        sessionStorage.removeItem("user")
        sessionStorage.removeItem("token")
        sessionStorage.removeItem('userInfo')
        this.deleteCookie("token")
        
        this.$router.push("/login")
        this.$api.login.logout().then((res) => {
          }).catch(function(res) {
        })
      })
      .catch(() => {})
    },
    // 删除cookie
    deleteCookie: function(name) { 
        Cookies.remove(name)
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit('setThemeColor', themeColor)
      Cookies.set('themeColor', themeColor)
    },
    // 打开备份还原界面
    showBackupDialog: function() {
      this.$refs.backupDialog.setBackupVisible(true)
    },
    // 成功还原之后，重新登录
    afterRestore: function() {
        this.$refs.backupDialog.setBackupVisible(false)
        sessionStorage.removeItem("user")
        this.deleteCookie("token")
        this.$router.push("/login")
        this.$api.login.logout().then((res) => {
          }).catch(function(res) {
        })
    }
  },
  created() {
    let cookieColor = Cookies.get('themeColor');
    if(cookieColor){
      this.$store.commit('setThemeColor', cookieColor)
    }
  },
  mounted() {
    var color = document.querySelector('.el-color-picker__trigger')
    var span = document.createElement('span')
    span.innerText='主题设置'
    span.classList.add('add-span')
    color.appendChild(span)
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
  }
}
</script>


<style lang="scss">
.update{
.el-dialog{
  .el-dialog__footer{
    text-align: center !important;
  }
}
.el-input__inner{
  height: 30px !important;
  line-height: 30px !important;
}
  .el-button{
    padding: 8px 14px !important;
  }
}

.other-operation-item{
  .el-color-picker--small .el-color-picker__trigger{
    width: 200px;
    height: 20px;
  }
  .el-color-picker__color{
    display: none;
  }
  .el-color-picker__icon{
    display: none;
  }
  .el-color-picker__trigger{
    border:none;
    padding: 0;
  }
  .el-color-picker--small{
    height: 20px;
  }

}
  .add-span{
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
  font-size: 14px;
}
</style>
<style scoped>
.personal-panel {
  font-size: 14px;
  width: 280px;
  text-align: center;
  border-color: rgba(180, 190, 190, 0.2);
  border-width: 1px;
  border-style: solid;
  background: rgba(182, 172, 172, 0.1);
  margin: -14px;
}
.personal-desc {
  padding: 15px;
  color: #fff;
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 90px;
}
.name-role {
  font-size: 16px;
  padding: 5px;
}
.personal-relation {
  font-size: 16px;
  padding: 12px;
  margin-right: 1px;
  background: rgba(200, 209, 204, 0.3);
}
.relation-item {
  padding: 12px;
}
.relation-item:hover {
  cursor: pointer;
  color: rgb(19, 138, 156);
}
.main-operation {
  padding: 8px;
  margin-right: 1px;
  /* background: rgba(175, 182, 179, 0.3); */
  border-color: rgba(201, 206, 206, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.main-operation-item {
  margin: 15px;
}
.other-operation {
  padding: 15px;
  margin-right: 1px;
  text-align: left;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.other-operation-item {
  padding: 12px;
}
.other-operation-item:hover {
  cursor: pointer;
  background: #9e94941e;
  color: rgb(19, 138, 156);
}
.personal-footer {
  margin-right: 1px;
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.personal-footer:hover {
  cursor: pointer;
  color: rgb(19, 138, 156);
  background: #b1a6a61e;
}
</style>


// WEBPACK FOOTER //
// src/views/Core/PersonalPanel.vue